import { DASHBOARD_BY_ID_PAGE, DASHBOARD_BY_ID_PATH } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';

export const dashboardByIdRoute = createSiteRoute({
	exact: true,
	name: DASHBOARD_BY_ID_PAGE,
	path: DASHBOARD_BY_ID_PATH + '/:dashboardId/:mode?',
	layout: 'expanded',
});
